import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { LogoLight } from "./Logo";
import { List, X } from "@phosphor-icons/react";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const linkCls = ({ isActive }) =>
    `text-sm uppercase tracking-[0.18em] font-sans transition-colors hover:text-gold ${
      isActive ? "text-gold" : "text-navy/80"
    }`;

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 backdrop-blur-xl bg-cream/85 border-b border-cream2"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" aria-label="LocalRida home">
          <LogoLight />
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/aruba" className={linkCls} data-testid="nav-aruba">Aruba</NavLink>
          <NavLink to="/how-it-works" className={linkCls} data-testid="nav-how">How It Works</NavLink>
          <NavLink to="/contact" className={linkCls} data-testid="nav-contact">Contact</NavLink>
          <Link
            to="/aruba"
            data-testid="nav-cta"
            className="bg-navy text-cream px-5 py-2.5 text-xs uppercase tracking-[0.2em] hover:bg-gold hover:text-navy transition-colors"
          >
            Book a Ride
          </Link>
        </nav>
        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-navy"
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} weight="thin" /> : <List size={24} weight="thin" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-cream2 bg-cream px-6 py-6 space-y-5" data-testid="nav-mobile-panel">
          <NavLink to="/aruba" onClick={() => setOpen(false)} className={linkCls} data-testid="nav-mobile-aruba">Aruba</NavLink>
          <div />
          <NavLink to="/how-it-works" onClick={() => setOpen(false)} className={linkCls} data-testid="nav-mobile-how">How It Works</NavLink>
          <div />
          <NavLink to="/contact" onClick={() => setOpen(false)} className={linkCls} data-testid="nav-mobile-contact">Contact</NavLink>
          <div />
          <Link
            to="/aruba"
            onClick={() => setOpen(false)}
            className="inline-block bg-navy text-cream px-5 py-3 text-xs uppercase tracking-[0.2em]"
            data-testid="nav-mobile-cta"
          >
            Book a Ride
          </Link>
        </div>
      )}
    </header>
  );
}
